// extracted by mini-css-extract-plugin
export default {"heading":"Vs-z","corrected":"Ws-z","redirectVerbiageContainer":"Xs-z","redirectVerbiageText":"Ys-z"};